export default () => ({
  user: {}
})
